import React, { useState, useCallback, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import Input from "../shared/input";
import PasswordChangeIcon from "../../assets/img/Account/password.webp";
import { changePassword } from "../../actions/account";
import CheckGreen from "../../assets/icon/check-lgreen.svg";
import XGray from "../../assets/icon/x-gray.svg";
import { logOutResetPassword } from "../../actions/account";
import styled from "styled-components";

const StyledChangePasswordButton = styled.button`
    ${props => props.brand && `
        background: ${props.brand.colors.theme} !important;
        &:not([disabled]) {
          border: 2px solid ${props.brand.colors.theme} !important;
        }

        &:hover {
            color: ${props.brand.colors.white} !important;
        }
    `}
`;

const SuccessModalContainer = styled.div`
    ${props => props.brand && `
        h2 {
            color: ${props.brand.colors.theme} !important;
        }

        .continueButton {
            border: 2px solid ${props.brand.colors.theme} !important;
            color: ${props.brand.colors.theme} !important;

            &:hover {
                color: ${props.brand.colors.white} !important;
                background: ${props.brand.colors.theme} !important;
            }
        }
    `}
`;

const defaultData = {
  oldPassword: "",
  newPassword: "",
};

export const Changepassword = () => {
  const user = JSON.parse(localStorage.getItem("profile"));
  const account = useSelector((state) => state.account);
  const { brand } = account;

  const [emailPass, setEmaillPass] = useState(false);
  const [formData, setFormData] = useState(defaultData);
  const [isDisabled, setDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [errorMess, setErrorOldPass] = useState("");
  const checkPasswordLength = formData.newPassword.length >= 8 ? true : false;
  const checkLetters = /^(?=.*[a-z])(?=.*[A-Z])/.test(formData.newPassword);
  const checkNumber = /^(?=.*[0-9])/.test(formData.newPassword);
  const checkCharacter = /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/.test(
    formData.newPassword
  );
  const dispatch = useDispatch();
  const history = useHistory();

  const handleClose = () => {
    setShowModal(false);
  };

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const validation = useCallback(() => {
    const passwordCheck =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~])[A-Za-z\d `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]{8,}$/.test(
        formData.newPassword
      );
    formData.oldPassword && formData.newPassword && passwordCheck
      ? setDisabled(false)
      : setDisabled(true);
  }, [formData]);

  const submit = () => {
    setIsLoading(true);
    dispatch(changePassword(user?.username, formData, brand.region));
  };

  const resetSession = () => {
    setErrorOldPass("");
    formData.oldPassword = "";
    formData.newPassword = "";
    var cartIFrame = document.getElementById("hidden-iframe");
    cartIFrame.contentWindow.postMessage(
      localStorage.removeItem("profile"),
      process.env[brand.apiUrlKey]
    );
    localStorage.removeItem("profile");
    setEmaillPass(false);
    setErrorOldPass("");
    dispatch(logOutResetPassword(user?.username, history));
  };

  useEffect(() => {
    if (account?.changePassword?.success) {
      setEmaillPass(true);
      setShowModal(false);
    } else {
      setEmaillPass(false);
    }

    if (account?.errorOldPass) {
      setEmaillPass(false);
      if (
        account?.errorOldPass?.message === "Incorrect username or password."
      ) {
        setErrorOldPass("Invalid Old Password");
      } else {
        setErrorOldPass(account?.errorOldPass?.message);
      }
    }
    setIsLoading(false);
  }, [account]);

  useEffect(() => {
    validation();
  }, [validation]);

    return <div className="changePasswordWrapper">
        <h2 className="sub-title">Login Details</h2>

        <div className="password-wrapper d-flex align-items-center justify-content-between">
            <div className="pl-5">Password</div>
            <div>
                <StyledChangePasswordButton
                    brand={brand}
                    className="changePasswordButton"
                    onClick={() => setShowModal(true)}
                >
                Change Password
                </StyledChangePasswordButton>
            </div>
        </div>

        <Modal
            id="changePasswordModal"
            className="modalWrapper"
            show={showModal}
            onHide={handleClose}
        >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
            <div>
                <h2 className="sub-title">Enter New Password</h2>
                <div className="password-input form-group">
                    <label htmlFor="oldPassword">Old Password</label>
                    <Input
                        label="Old Password"
                        name="oldPassword"
                        type="password"
                        value={formData.oldPassword}
                        onChange={handleChange}
                    />
                    <p className={"invalidPassword "}>
                        {errorMess ? errorMess : ""}
                    </p>
                </div>
                <div className="password-input form-group">
                    <label htmlFor="confirmNewPassword">New Password</label>
                    <Input
                        label="Password"
                        name="newPassword"
                        type="password"
                        value={formData.newPassword}
                        onChange={handleChange}
                    />
                    <p
                        className={
                            "password-validation " +
                            (checkPasswordLength ? "valid" : "")
                        }
                    >
                        {
                            checkPasswordLength
                                ? <img src={CheckGreen} alt="" />
                                : <img src={XGray} alt="" />
                        }{" "}
                        Use 8 or more characters
                    </p>
                    <p
                        className={
                            "password-validation " + (checkLetters ? "valid" : "")
                        }
                    >
                        {
                            checkLetters
                                ? <img src={CheckGreen} alt="" />
                                : <img src={XGray} alt="" />
                        }{" "}
                        Use upper and lower case letters
                    </p>
                    <p className={"password-validation " + (checkNumber ? "valid" : "")}>
                        {
                            checkNumber
                                ? <img src={CheckGreen} alt="" />
                                : <img src={XGray} alt="" />
                        }{" "}
                        Use a number (e.g. 1234)
                    </p>
                    <p className={"password-validation " + (checkCharacter ? "valid" : "")}>
                        {
                            checkCharacter
                                ? <img src={CheckGreen} alt="" />
                                : <img src={XGray} alt="" />
                        }{" "}
                        Use a symbol (e.g. !@#$)
                    </p>
                </div>
            </div>
            <div className="d-flex align-items-center justify-content-start nav">
                <div>
                    <StyledChangePasswordButton
                        brand={brand}
                        className="changePasswordButton"
                        onClick={submit}
                        disabled={isDisabled}
                    >
                        {
                            isLoading
                                ? <div className="spinner-border text-light" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                            : <>{"Change Password"}</>
                        }
                    </StyledChangePasswordButton>
                </div>
            </div>
        </Modal.Body>
        </Modal>

        {
            emailPass
            && <SuccessModalContainer brand={brand} className="checkEmail-container">
                <div className="contentWrapper text-center">
                    <img
                        className="emailIcon"
                        alt="email icon"
                        src={PasswordChangeIcon}
                    />
                    <h2>Password completely set</h2>
                    <p>You have set a new password. Remember to keep it saved!</p>
                    <div className="emailSubmitWrapper">
                        <button className="continueButton" onClick={resetSession}>
                            Thank You
                        </button>
                    </div>
                </div>
            </SuccessModalContainer>
        }
    </div>
};
